import { useTranslation } from "react-i18next";
import { Button } from "~/atoms/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "~/atoms/dialog";
import ProgressCircle from "~/atoms/progress-circle";
import { ReadersOverview } from "~/organisms/ReadersOverview";

interface Props {
  documentVersionId: number;
  openedCount: number;
  readCount: number;
  totalCount: number;
  canSeeDetails: boolean;
}

export const PublishReportProgress = ({
  documentVersionId,
  openedCount,
  readCount,
  totalCount,
  canSeeDetails,
}: Props) => {
  const { t } = useTranslation();

  if (totalCount === 0) {
    return null;
  }

  const openedValue = (openedCount / totalCount) * 100;
  const readValue = (readCount / totalCount) * 100;

  const openedColor =
    openedValue < 33 ? "destructive" : openedValue < 66 ? "warning" : "success";

  const readColor =
    readValue < 33 ? "destructive" : readValue < 66 ? "warning" : "success";

  return (
    <>
      <div className="flex justify-around">
        <div className="flex flex-col items-center gap-1">
          <ProgressCircle value={openedValue} color={openedColor} />
          <div className="text-muted-foreground text-xs">
            {t(($) => $.commons.documentStatus.opened)}
          </div>
        </div>
        <div className="flex flex-col items-center gap-1">
          <ProgressCircle value={readValue} color={readColor} />
          <div className="text-muted-foreground text-xs">
            {t(($) => $.commons.documentStatus.accepted)}
          </div>
        </div>
      </div>

      {canSeeDetails && (
        <Dialog>
          <DialogTrigger asChild>
            <Button size="sm" variant="outline">
              {t(($) => $.commons.buttons.showMore)}
            </Button>
          </DialogTrigger>
          <DialogContent className="min-w-250">
            <DialogHeader>
              <DialogTitle>{t(($) => $.modal.infoReaders.title)}</DialogTitle>
              <DialogDescription>
                {t(($) => $.modal.infoReaders.description)}
              </DialogDescription>
            </DialogHeader>
            <ReadersOverview
              documentVersionId={documentVersionId}
              isRemoveAllowed={false}
            />
            <DialogFooter>
              <DialogClose asChild>
                <Button variant="secondary">
                  {t(($) => $.commons.buttons.close)}
                </Button>
              </DialogClose>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};
